import React from "react";
import Navbar from "../Components/Navbar";
import Hero from "../Components/Hero";
import Info from "../Components/Info";
import About from "../Components/About";
import BookAppointment from "../Components/BookAppointment";
import Databases from "../Components/Databases";
import Footer from "../Components/Footer";
import Middlewares from "../Components/Middlewares";

function Home() {
    return (
        <div className="home-section">
            <Navbar/>
            <Hero/>
            <Databases/>
            <Info/>
            <Middlewares/>
            <About/>
            <BookAppointment/>
            <Footer/>
        </div>
    );
}

export default Home;
